import React from 'react';
import type { IFormElement } from '../types';
import styles from './fields.module.css';

export interface PanelFieldProps {
  element: IFormElement;
  children?: React.ReactNode;
}

export const PanelField: React.FC<PanelFieldProps> = ({
  element,
  children,
}) => {
  return (
    <div
      className={styles.formField}
      style={{
        padding: '1.5rem',
        backgroundColor: 'var(--df-background-panel, #fafafa)',
        borderRadius: '8px',
        border: '1px solid #eee',
      }}
    >
      {element.title && (
        <h3
          style={{
            margin: '0 0 0.5rem 0',
            fontSize: '1.125rem',
            fontWeight: 600,
            color: 'var(--df-text-primary, #1a1a1a)',
          }}
        >
          {element.title}
        </h3>
      )}
      {element.description && (
        <p className={styles.description} style={{ marginBottom: '1rem' }}>
          {element.description}
        </p>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {children}
      </div>
    </div>
  );
};

export default PanelField;
